import { IonHeader, IonToolbar, IonTitle, IonButtons, useIonViewWillEnter } from '@ionic/react';
import React, { useEffect, useState, useCallback } from 'react';
import './HeaderSos3.css';
import MenuButton from './MenuButton';
import env from '../env.json';
import axios from 'axios';
import { StatusBar } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

interface ContainerProps {
    pageName: string;
}

const HeaderSos3: React.FC<ContainerProps> = ({ pageName }) => {
    const [inPlace, setInPlace] = useState("");
    const [number, setNumber] = useState("");
    const [state, setState] = useState("");

    const url = env.REACT_APP_URL;

    // --- Lógica del color de la barra de estado ---
    useIonViewWillEnter(() => {
        const setStatusBarColor = async () => {
            if (Capacitor.isNativePlatform()) {
                await StatusBar.setBackgroundColor({ color: '#e5100b' });
            }
        };
        setStatusBarColor();
    });
    // --- Fin de la lógica del color ---


    const sos = useCallback(async () => {
        try {
            const token = localStorage.getItem('token');
            const header = {
                'Authorization': 'Bearer ' + token
            };

            const instance = axios.create({
                baseURL: url,
                headers: header
            });

            const res = await instance.get('/api/sos/0');
            setNumber(res.data.number);
            setInPlace(res.data.ubicacion);

            const statusMap: { [key: string]: string } = {
                'danger': 'Pendiente',
                'CHECK': 'En espera por cierre del usuario',
                'PROGRESS': 'En revisión',
                'COMPLETED': 'Resuelto'
            };

            setState(statusMap[res.data.status] || 'Desconocido');
        } catch (error) {
            console.error("Error al obtener el SOS:", error);
        }
    }, [url]);

    const verifyCaseState = useCallback(() => {
        const interval = setInterval(() => {
            sos();

            setState((prevState) => {
                if (prevState === 'Resuelto') {
                    localStorage.removeItem('status');
                    window.location.href = '/boton-sos';
                    clearInterval(interval);
                }
                return prevState;
            });
        }, 10000);

        return () => clearInterval(interval);
    }, [sos]);

    useEffect(() => {
        sos();
        const cleanup = verifyCaseState();
        return cleanup;
    }, [sos, verifyCaseState]);


    return (
        <IonHeader mode="ios" className="header-red-3 ion-no-border">
            <IonToolbar className="header-page-3 header-sos-background-color">
                <IonButtons slot="start">
                    <MenuButton />
                </IonButtons>
                <IonTitle>{pageName}</IonTitle>
            </IonToolbar>

            <div className='container inputsos justify-content-center row'>
                <div className='div-sos-3'>
                    <label className='label-sos-3'>Tipo de alerta</label>
                    <input className='input-sos-3' type="text" value="Emergencia de seguridad" readOnly />
                </div>
                <div className='div-sos-3'>
                    <label className='label-sos-3'>¿En el bien protegido?</label>
                    <input className='input-sos-3' type="text" value={inPlace} readOnly />
                </div>
                <div className='div-sos-3'>
                    <label className='label-sos-3'>Número de caso</label>
                    <input className='input-sos-3' type="text" value={number} readOnly />
                </div>
                <div className='div-sos-3'>
                    <label className='label-sos-3'>Estado del caso</label>
                    <input className='input-sos-3' type="text" value={state} readOnly />
                </div>
            </div>
        </IonHeader>
    );
};

export default HeaderSos3;